<ng-container *ngIf="!showSpinner && (requiredDocs$ | async) as docs; else spinner">
  <ng-container *ngIf="docs.length > 0;">
    <bw-action-article-legacy
      [brightsideWebFb]="{ event_name: 'legal_documents' }">
      <div header-actions *ngIf="showBackbutton || showCloseButton">
        <ui-nav-exit-back
          *ngIf="showBackbutton"
          [trackingDetail]="{ event_name: 'legal_documents' }"
          [skipActionEmit]="skipActionEmit"
          (exitActionHandler)="emitBackButtonEvent()"
        ></ui-nav-exit-back>
        <bw-icon-legacy
          *ngIf="showCloseButton"
          iconName="close"
          size="24"
          (click)="handleCloseClick()"
        ></bw-icon-legacy>
      </div>
      <div content-section>
        <typography-legacy title-medium class="mb-sm" color="var(--primary-text)">
          <div [innerHTML]="titleCopy() | translate"></div>
        </typography-legacy>
        <typography-legacy text-medium-regular class="mb-md" color="var(--secondary-text)">
          <div [innerHTML]="descriptionCopy() | translate"></div>
        </typography-legacy>
        @if(legalType === 'consent') {
          <ng-container *ngFor="let doc of docs">
            <div class="mb-sm">
              <typography-legacy *ngIf="doc.titleCopyKey" text-medium-semibold color="var(--primary-text)">
                <div [innerHTML]="doc.titleCopyKey | translate" class="mb-xs"></div>
              </typography-legacy>
              <typography-legacy *ngIf="doc.descriptionCopyKey" text-xsmall-regular color="var(--secondary-text)">
                <div [innerHTML]="doc.descriptionCopyKey | translate"></div>
              </typography-legacy>
              <a style="text-decoration: underline" target="_blank" (click)="handleDocClick(doc.downloadUrl, $event)">
                <typography-legacy text-xsmall-regular>
                  <div [innerHTML]="doc.downloadUrlCopyKey | translate"></div>
                </typography-legacy>
              </a>
            </div>
          </ng-container>
        }
      </div>

      @if(legalType === 'consent') {
        <div footer-top class="flex-row space-center">
          <form [formGroup]="confirmDataForm">
            <bw-checkbox-legacy [formControlName]="'confirmCheckbox'">
              <typography-legacy text-medium color="var(--primary-text)">
                {{ 'LEGAL_DOCUMENTS_AGREEMENT' | translate }}
              </typography-legacy>
            </bw-checkbox-legacy>
          </form>
        </div>
      }
      <div footer-actions>
        <button
          bw-button-legacy
          type="submit"
          (click)="onSubmit()"
          [disabled]="confirmDataForm.invalid || (processing | async)"
          [processing]="(processing | async)"
          [brightsideWebFb]="{ event_name: 'legal_documents' }"
        >
          {{ ctaKey | translate }}
        </button>

        <button
          *ngIf="deferrable | async"
          bw-link-button-legacy (click)="deferAcceptance()"
          [brightsideWebFb]="{ event_name: 'legal_documents' }" [secondaryCta]="true">
          {{ 'legal_documents_cta2'.toUpperCase() | translate }}
        </button>
      </div>

    </bw-action-article-legacy>

    <bw-modal-legacy *ngIf="displayDocsRequiredModal | async" modalWidth="medium"
              [showCloseButton]="false">
      <typography-legacy title-medium color="var(--primary-text)" class="mb-sm">{{ 'ERROR_ADDITIONAL_DOCS_REQUIRED_TITLE' | translate }}</typography-legacy>
      <section class="body">
        <bw-paragraph-legacy>
          <typography-legacy text-large-regular color="var(--secondary-text)">
            <p class="mb-xs">
              {{ 'ERROR_ADDITIONAL_DOCS_REQUIRED_DESC' | translate }}
            </p>
          </typography-legacy>
        </bw-paragraph-legacy>
      </section>
      <footer class="footer">
        <div class="flex-row row-reverse">
          <button
            bw-button-legacy
            [brightsideWebFb]="{ event_name: 'legal_documents_required' }"
            (click)="refetchDocuments()">
            {{ 'BUTTON_CONTINUE' | translate }}
          </button>
        </div>
      </footer>
    </bw-modal-legacy>


    <bw-modal-legacy *ngIf="displayGeneralError | async" modalWidth="medium"
              [showCloseButton]="false"
              [brightsideWebFb]="{ event_name: 'error_shown', custom: { 'error id': 'legal_documents'}}">
      <typography-legacy title-medium color="var(--primary-text)" class="mb-sm">
        {{ 'PROCESS_ERROR_TITLE' | translate }}
      </typography-legacy>
      <section class="body">
        <bw-paragraph-legacy>
          <typography-legacy text-large-regular color="var(--secondary-text)">
            <p class="mb-xs">
              {{ 'PROCESS_ERROR_MSG' | translate }}
            </p>
          </typography-legacy>
        </bw-paragraph-legacy>
      </section>
      <footer class="footer">
        <div class="flex-row row-reverse">
          <button
            bw-button-legacy
            (click)="closeError()">
            {{ 'BUTTON_CONTINUE' | translate }}
          </button>
        </div>
      </footer>
    </bw-modal-legacy>
  </ng-container>
</ng-container>


<ng-template #spinner>
  <bw-action-article-legacy>
    <div content-section>
      <div class="flex-column space-center">
        <bw-spinner-legacy></bw-spinner-legacy>
      </div>
    </div>
  </bw-action-article-legacy>
</ng-template>
